import { render, staticRenderFns } from "./ui-file-input.vue?vue&type=template&id=682ab29b"
import script from "./ui-file-input.vue?vue&type=script&lang=ts"
export * from "./ui-file-input.vue?vue&type=script&lang=ts"
import style0 from "./ui-file-input.vue?vue&type=style&index=0&id=682ab29b&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports